import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../helpers/string.helper';

@Pipe({ name: 'clickableUrl' })
export class ClickableUrlPipe implements PipeTransform {
  constructor() {}

  transform(value: string): string {
    return StringHelper.parseUrlLink(value);
  }
}
